import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Inventory({ user, tabData }) {
    const [inventory, setInventory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState({ id: null, item_name: '', category: '', quantity: '', unit: 'Adet', min_level: '', unit_price: '' });
    const [categoryFilter, setCategoryFilter] = useState('');
    const [showLowStock, setShowLowStock] = useState(false);

    useEffect(() => {
        fetchInventory();
        if (tabData?.filterLowStock) {
            setShowLowStock(true);
        }
    }, [tabData]);

    const fetchInventory = () => {
        axios.get('./backend/get_inventory.php')
            .then(res => {
                setInventory(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post('./backend/save_inventory.php', currentItem)
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchInventory();
            })
            .catch(err => toast.error('İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu ürünü silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_inventory.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchInventory();
                });
        }
    };

    const openModal = (item = { id: null, item_name: '', category: '', quantity: '', unit: 'Adet', min_level: 10, unit_price: '' }) => {
        setCurrentItem(item);
        setShowModal(true);
    };

    const handleExport = () => {
        const BOM = "\uFEFF";
        const headers = ["ID", "Ürün Adı", "Kategori", "Miktar", "Birim", "Birim Fiyat", "Toplam Değer", "Kritik Seviye", "Son Güncelleme"];
        const csvContent = headers.join(";") + "\n" + inventory.map(item => {
            return [
                item.id,
                `"${item.item_name}"`,
                `"${item.category || ''}"`,
                item.quantity,
                `"${item.unit}"`,
                parseFloat(item.unit_price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 }),
                (parseFloat(item.unit_price || 0) * parseInt(item.quantity || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2 }),
                item.min_level,
                `"${new Date(item.updated_at).toLocaleString()}"`
            ].join(";");
        }).join("\n");

        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "stok_listesi.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (loading) return <div>Yükleniyor...</div>;

    // Kategorileri al
    const categories = [...new Set(inventory.map(item => item.category).filter(c => c))];

    // Filtreleme
    const filteredInventory = inventory.filter(item => {
        if (categoryFilter && item.category !== categoryFilter) return false;
        if (showLowStock && parseInt(item.quantity) > parseInt(item.min_level)) return false;
        return true;
    });

    // Toplam Stok Değeri Hesaplama
    const totalInventoryValue = filteredInventory.reduce((sum, item) => {
        return sum + (parseInt(item.quantity || 0) * parseFloat(item.unit_price || 0));
    }, 0);

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Stok Takibi</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                        className="add-btn" 
                        onClick={() => setShowLowStock(!showLowStock)}
                        style={{ background: showLowStock ? '#e74a3b' : '#858796', boxShadow: 'none' }}
                    >
                        {showLowStock ? 'Tümünü Göster' : <><img src="/uploads/iconpack/error.svg" alt="Uyarı" style={{ width: '18px', height: '18px' }} /> Kritik Stok</>}
                    </button>
                    <select 
                        value={categoryFilter} 
                        onChange={(e) => setCategoryFilter(e.target.value)}
                        style={{ padding: '8px', borderRadius: '20px', border: '2px solid #eaecf4', outline: 'none', cursor: 'pointer' }}
                    >
                        <option value="">Tüm Kategoriler</option>
                        {categories.map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                        ))}
                    </select>
                    <button className="add-btn" onClick={handleExport} style={{ background: 'linear-gradient(135deg, #f6c23e 0%, #dda20a 100%)', boxShadow: '0 4px 15px rgba(246, 194, 62, 0.4)' }}>Excel'e Aktar</button>
                    {user.role === 'admin' && (
                        <button className="add-btn" onClick={() => openModal()}>+ Yeni Ürün Ekle</button>
                    )}
                </div>
            </div>

            {/* Toplam Stok Değeri Kartı */}
            <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                <div style={{ flex: 1, background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', borderLeft: '5px solid #4e73df' }}>
                    <h3 style={{ margin: 0, color: '#5a5c69', fontSize: '0.9rem', textTransform: 'uppercase' }}>Toplam Stok Değeri</h3>
                    <p style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#4e73df', margin: '10px 0 0 0' }}>{totalInventoryValue.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</p>
                </div>
            </div>

            <table className="data-table inventory-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Ürün Adı</th>
                        <th>Kategori</th>
                        <th>Miktar</th>
                        <th>Birim</th>
                        <th>Birim Fiyat</th>
                        <th>Toplam Değer</th>
                        <th>Kritik Seviye</th>
                        <th>Son Güncelleme</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredInventory.map(item => (
                        <tr key={item.id} style={parseInt(item.quantity) <= parseInt(item.min_level) ? {backgroundColor: '#ffebee', borderLeft: '5px solid #e74a3b'} : {}}>
                            <td data-label="ID">{item.id}</td>
                            <td data-label="Ürün Adı">{item.item_name}</td>
                            <td data-label="Kategori">{item.category || '-'}</td>
                            <td data-label="Miktar" style={{fontWeight: 'bold', color: parseInt(item.quantity) <= parseInt(item.min_level) ? '#e74a3b' : 'inherit'}}>{item.quantity}</td>
                            <td data-label="Birim">{item.unit}</td>
                            <td data-label="Birim Fiyat">{parseFloat(item.unit_price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                            <td data-label="Toplam Değer" style={{fontWeight: 'bold', color: '#4e73df'}}>{(parseFloat(item.unit_price || 0) * parseInt(item.quantity || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                            <td data-label="Kritik Seviye">{item.min_level}</td>
                            <td data-label="Son Güncelleme">{new Date(item.updated_at).toLocaleDateString()}</td>
                            <td data-label="İşlemler">
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    {user.role === 'admin' && (
                                        <>
                                            <button className="edit-btn" onClick={() => openModal(item)}>Düzenle</button>
                                            <button className="delete-btn" onClick={() => handleDelete(item.id)}>Sil</button>
                                        </>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                    {filteredInventory.length === 0 && <tr><td colSpan="10" style={{textAlign:'center'}}>Kayıtlı ürün bulunamadı.</td></tr>}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{currentItem.id ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="inventoryForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Ürün Adı</label>
                                    <input type="text" value={currentItem.item_name} onChange={e => setCurrentItem({...currentItem, item_name: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>Kategori</label>
                                    <input type="text" value={currentItem.category} onChange={e => setCurrentItem({...currentItem, category: e.target.value})} placeholder="Örn: Sarf Malzeme, İmplant..." />
                                </div>
                                <div className="responsive-grid-2">
                                    <div className="form-group">
                                        <label>Miktar</label>
                                        <input type="number" value={currentItem.quantity} onChange={e => setCurrentItem({...currentItem, quantity: e.target.value})} required />
                                    </div>
                                    <div className="form-group">
                                        <label>Birim</label>
                                        <input type="text" value={currentItem.unit} onChange={e => setCurrentItem({...currentItem, unit: e.target.value})} placeholder="Adet, Kutu, Lt" required />
                                    </div>
                                    <div className="form-group">
                                        <label>Birim Fiyat (TL)</label>
                                        <input type="number" step="0.01" value={currentItem.unit_price} onChange={e => setCurrentItem({...currentItem, unit_price: e.target.value})} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Kritik Seviye (Uyarı Limiti)</label>
                                    <input type="number" value={currentItem.min_level} onChange={e => setCurrentItem({...currentItem, min_level: e.target.value})} required />
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="inventoryForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Inventory;